import { ActionCreatorsMapObject, Dispatch, ActionCreator } from 'redux';
import { ThunkAction } from 'redux-thunk';
import axios from 'axios';
import {
    IWorkspaceState,
    IWorkspaceAction,
} from '../../common/model/WorkspaceModels';
import { sec } from '../../security';
import config from '../../auth.config';
const API_ROOT = process.env.REACT_APP_API_ROOT;

export const types = {
    LIST_ACTIVITIES_REQUEST: 'LIST_ACTIVITIES_REQUEST',
    LIST_ACTIVITIES_SUCCESS: 'LIST_ACTIVITIES_SUCCESS',
    LIST_MORE_ACTIVITIES_SUCCESS: 'LIST_MORE_ACTIVITIES_SUCCESS',
    NEW_ACTIVITIES_SUCCESS: 'NEW_ACTIVITIES_SUCCESS',
    LIST_ACTIVITIES_FAILURE: 'LIST_ACTIVITIES_FAILURE',
};

export const getActivities: ActionCreator<
    ThunkAction<Promise<any>, IWorkspaceState, null, IWorkspaceAction>
> =
    (
        id: string,
        limit: number,
        skip: number,
        sort: string,
        direction: string,
        fetchMore: boolean
    ) =>
    async (dispatch: Dispatch) => {
        const access_token = await sec.getAccessTokenSilently()({
            audience: config.audience,
        });

        dispatch({
            type: types.LIST_ACTIVITIES_REQUEST,
        });

        try {
            const response = await axios({
                method: 'GET',
                url: `${API_ROOT}/activities/list`,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json;charset=UTF-8',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + access_token,
                },
                params: {
                    workspaceId: id,
                    limit,
                    skip,
                    sort,
                    direction,
                },
            });

            if (!fetchMore) {
                dispatch({
                    type: types.LIST_ACTIVITIES_SUCCESS,
                    payload: response.data,
                    id,
                });
            } else {
                dispatch({
                    type: types.LIST_MORE_ACTIVITIES_SUCCESS,
                    payload: response.data,
                    id,
                });
            }
        } catch (error) {
            console.log('Get AuditWrapper List Error', error);
            dispatch({ type: types.LIST_ACTIVITIES_FAILURE, error, id });
        }
    };

export const auditActions: ActionCreatorsMapObject<
    ThunkAction<Promise<any>, IWorkspaceState, null, IWorkspaceAction>
> = {
    getActivities,
};
